import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { VenusModal } from 'src/skins/venus/components/common';
import { DashboardLayout } from 'src/skins/venus/components/layouts';
import { TermsContent } from 'src/skins/common/components';

const Wrapper = styled.div`
  margin-bottom: 3.5rem;
`;

export const Terms = () => {
  const history = useHistory();

  return (
    <DashboardLayout>
      <VenusModal
        isOpen={true}
        closeModal={() => history.replace('/dashboard/settings')}
        fullheight={true}
        backgroundPage="settings"
      >
        <Wrapper>
          <h4>Terms of use</h4>

          <br />

          <TermsContent />
        </Wrapper>
      </VenusModal>
    </DashboardLayout>
  );
};

export default Terms;
